import moment from "moment";
import {
  BENEFIT_TYPE,
  CalenderOperationType,
  EXCLUSION_TYPE,
  ORDER_STATUS_MAPPING,
  ProductType,
} from "./enums";

export function checkIfRewardIsApplied(order) {
  let isRewardApplied = false;
  for (let i = 0; i < order?.lineItems?.length; i++) {
    if (order?.lineItems[i]?.rewardId) {
      isRewardApplied = true;
      break;
    }
    for (let j = 0; j < order?.lineItems[i]?.addOns.length; j++) {
      if (order?.lineItems[i]?.addOns[j]?.rewardId) {
        isRewardApplied = true;
        break;
      }
    }
  }
  return isRewardApplied;
}

export const generateSlots = (date) => {
  let offsetDate = moment(date);
  const isScheduledDateToday =
    moment(date).format("DD MM YYYY") === moment().format("DD MM YYYY");
  // if (!isScheduledDateToday) {
  offsetDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  // }

  let hour = offsetDate.hour();
  let minute = offsetDate.minute();

  // Rounding minute on 30 mins interval
  // if (minute <= 30) offsetDate.set({ minute: 30 });
  // if (minute > 30) offsetDate.set({ hour: hour + 1, minute: 0 });

  let shiftStart = moment(offsetDate).set({
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });

  let shiftEnd = moment(offsetDate).set({
    hours: 24,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });

  const timeslots = [];

  do {
    if (offsetDate.isSameOrAfter(shiftStart))
      timeslots.push({
        label: offsetDate.format("LT"),
        value: offsetDate.format("LT"),
        // disabled: disabled,
      });
    offsetDate = offsetDate.add(15, "minute");
  } while (offsetDate.isBefore(shiftEnd));

  return timeslots;
};

const generateMobileSlots = (n, date) => {
  let offsetDate = moment();
  let scheduledDate = moment(date);
  const isScheduledDateToday =
    scheduledDate.format("DD MM YYYY") === moment().format("DD MM YYYY");
  // if (!isScheduledDateToday) {
  offsetDate = moment(scheduledDate);
  offsetDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  scheduledDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  // }

  const hoursPlusNMoment = moment().add(n, "hours");
  const currentHr24Plus2 = 0;
  const slots = [];
  for (let i = 0; i < 24; i++) {
    let hr = currentHr24Plus2 + i;
    let date = moment(offsetDate);
    date.hour(hr);

    if (
      1
      // date >= scheduledDate &&
      // !(date.format("DD") !== scheduledDate.format("DD")) &&
      // date.isAfter(hoursPlusNMoment)
    ) {
      let disabled = false;
      let preDate = moment(date).set({
        // hours: 8,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });
      let postDate = moment(date).set({
        // hours: isMobile ? 20 : 19,
        hours: 24,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });
      if (date.isBefore(preDate)) {
        continue;
      } else if (date.isAfter(postDate)) {
        continue;
        disabled = true;
      }
      slots.push({
        label: `${moment(hr, "hh").format("LT")}`,
        value: moment(hr, "hh").format("LT"),
        // disabled: disabled,
      });
    }
  }
  return slots;
};

export const generateHourlyTimeslotsAfterNHours = (n, date, isMobile) => {
  return generateSlots(date);
};

export const checkIsMobileBooking = (booking) => {
  return booking?.operationTypeId === 1;
};
export const checkIsClinicBooking = (booking) => {
  return booking?.operationTypeId === 2;
};

export const checkIsTeleHealthBooking = (booking) => {
  return booking?.operationTypeId === 3;
};

export const isUserNurse = (user) => {
  const roleName = user?.roleName?.trim?.();
  return (
    roleName === "Nurse" ||
    roleName === "Nurse Practitioner" ||
    roleName === "Nurse Lead"
  );
};

export const isNurseRole = (user, roles) => {
  const role = roles?.find?.((role) => role?.roleId === user?.roleId);
  const roleName = user?.roleName?.trim?.();
  return (
    roleName === "Nurse" ||
    roleName === "Nurse Practitioner" ||
    roleName === "Nurse Lead"
  );
};

export const verifyRoutePermission = (route, permissions, ignore) => {
  if (ignore) return true;

  if (
    route?.name === "calendar" &&
    !permissions?.find((permission) => {
      return permission?.permissionName === "Scheduling";
    })
  )
    return false;

  if (
    route?.name === "staff" &&
    !permissions?.find((permission) => {
      return permission?.permissionName === "Settings";
    })
  )
    return false;

  if (
    route?.name === "settings" &&
    !permissions?.find((permission) => {
      return permission?.permissionName === "Settings";
    })
  )
    return false;

  return true;
};

export const addonsTextReducer = (prev, curr, currentIndex, array) => {
  let seperator = ",";
  if (!prev) seperator = "";
  if (currentIndex === array.length - 1) seperator = " and ";
  if (array?.length <= 1) seperator = "";
  return prev + `${seperator} ` + curr?.productName;
};

export const isDosageTemplate = (element) => {
  if (element?.key === "DosageTemplate") return true;
  return false;
};

export const isFormBuilderInputField = (element) => {
  if (
    element.element === "TextInput" ||
    element.element === "EmailInput" ||
    element.element === "NumberInput" ||
    element.element === "PhoneNumber" ||
    element.element === "TextArea" ||
    element.element === "DatePicker" ||
    element.element === "Dropdown"
  ) {
    return true;
  }
  return false;
};
export const arrayCommaSeperatedReducer = (prev, curr, currentIndex, array) => {
  let seperator = ",";
  if (!prev) seperator = "";
  if (currentIndex === array.length - 1) seperator = " and ";
  if (array?.length <= 1) seperator = "";
  return prev + `${seperator} ` + curr;
};

export function format_number(number, num_decimals, include_comma) {
  return number.toLocaleString("en-US", {
    useGrouping: include_comma,
    minimumFractionDigits: num_decimals,
    maximumFractionDigits: num_decimals,
  });
}

export const generateHourlySlots = (startTime = "09:00", endTime = "18:00") => {
  const startDate = moment();
  startDate.set({
    hours: startTime.split(":")[0],
    minutes: startTime.split(":")[1],
    seconds: 0,
    milliseconds: 0,
  });

  const endDate = moment();
  endDate.set({
    hours: endTime.split(":")[0],
    minutes: endTime.split(":")[1],
    seconds: 0,
    milliseconds: 0,
  });

  let iterator = moment(startDate);
  const slots = [];
  while (iterator <= endDate) {
    slots.push({
      label: iterator.format("LT"),
      value: iterator.format("LT"),
      disabled: true,
    });
    iterator = iterator.add(30, "minutes");
  }

  return slots;
};

export const getLegacyChartURL = (orderId, lineItemId, productName) => {
  switch (productName) {
    case "Abdominal Discomfort":
      return `/dashboard/charts/${orderId}/abdominalDiscomfort/${lineItemId}`;
    case "Allergies":
      return `/dashboard/charts/${orderId}/allergies/${lineItemId}`;
    case "Cold & Flu":
      return `/dashboard/charts/${orderId}/coldAndFlu/${lineItemId}`;
    case "Covid Testing":
      return `/dashboard/charts/${orderId}/covidTesting/${lineItemId}`;
    case "Dehydration":
      return `/dashboard/charts/${orderId}/dehydration/${lineItemId}`;
    case "Energy":
      return `/dashboard/charts/${orderId}/energyBoost/${lineItemId}`;
    case "Fatigue & Jet Lag":
      return `/dashboard/charts/${orderId}/fatigueAndJetLag/${lineItemId}`;
    case "Hangover Relief":
      return `/dashboard/charts/${orderId}/hangoverRelief/${lineItemId}`;
    case "NAD+ (High Dose)":
      return `/dashboard/charts/${orderId}/highDoseNAD/${lineItemId}`;
    case "Hydration":
      return `/dashboard/charts/${orderId}/hydration/${lineItemId}`;
    case "IM Injection":
      return `/dashboard/charts/${orderId}/iMInjection/${lineItemId}`;
    case "Migraine":
      return `/dashboard/charts/${orderId}/migraine/${lineItemId}`;
    case "Mental Clarity":
      return `/dashboard/charts/${orderId}/mentalClarity/${lineItemId}`;
    case "Immunity & Defense":
      return `/dashboard/charts/${orderId}/immunityBoostDefense/${lineItemId}`;
    case "NAD+ (Low Dose)":
      return `/dashboard/charts/${orderId}/lowDoseNAD/${lineItemId}`;
    case "Myers Cocktail":
      return `/dashboard/charts/${orderId}/myersCocktail/${lineItemId}`;
    case "Nausea & Vomiting Relief":
      return `/dashboard/charts/${orderId}/nauseaAndVomiting/${lineItemId}`;
    case "Performance & Recovery":
      return `/dashboard/charts/${orderId}/performanceAndRecovery/${lineItemId}`;
    case "Weight Management":
      return `/dashboard/charts/${orderId}/weightManagement/${lineItemId}`;
    default:
      return `/dashboard/charts/${orderId}/beautifyAndGlow/${lineItemId}`;
  }
};

export const openChartURL = (
  orderId,
  lineItemId,
  { isLegacy = false, productName = "" }
) => {
  let url = "";
  if (isLegacy) url = getLegacyChartURL(orderId, lineItemId, productName);
  else url = `/dashboard/chartsv2/${orderId}/${lineItemId}`;
  window.open(url, "_blank");
};

export const convertMinsToHrsMins = (mins) => {
  let h = Math.floor(mins / 60);
  let m = Math.round(mins % 60);
  // h = h < 10 ? "0" + h : h; // (or alternatively) h = String(h).padStart(2, '0')
  m = m < 10 ? "0" + m : m; // (or alternatively) m = String(m).padStart(2, '0')
  return `(${h}hr ${m}min)`;
};
export function hoursList(length, text) {
  let hours = [];
  for (let index = 1; index < length; index++) {
    hours.push({ label: `${index} ${text}`, value: index });
  }
  return hours;
}

export const getProductTypeFromOperation = (operationTypeId) => {
  return operationTypeId === CalenderOperationType.Telehealth
    ? ProductType.Telehealth
    : ProductType.Service;
};

export const checkForProductExcludeType = (
  myreward = {},
  values = {},
  excludeRewards = []
) => {
  let availableCustomerRewardIds = [];
  if (myreward.productExcludeType === EXCLUSION_TYPE["All Included"]) {
    // saari products pe ye reward apply krdo
    availableCustomerRewardIds = myreward?.customerRewardIds;
  } else if (myreward.productExcludeType === EXCLUSION_TYPE["Only Included"]) {
    // jo productIds ki collection mai ho sirf unhi pe apply krdo
    if (myreward.productIds.includes(values.productId)) {
      availableCustomerRewardIds = myreward?.customerRewardIds;
    }
  } else if (
    myreward.productExcludeType === EXCLUSION_TYPE["All Included Except"]
  ) {
    // jo productIds ki collection mai ho unke elawa sb pe apply krdo
    if (!myreward.productIds.includes(values.productId)) {
      availableCustomerRewardIds = myreward?.customerRewardIds;
    }
  }

  // redemptionLimit caps how many times each customerRewardId can be used; null/undefined/-1 means unlimited
  const limit = myreward?.redemptionLimit;
  const isUnlimited = limit === null || limit === undefined || limit === -1;
  return (availableCustomerRewardIds ?? []).find(
    (customerRewardId) =>
      isUnlimited ||
      excludeRewards.filter((id) => id === customerRewardId).length < limit
  );
};

export const getRewardId = (rewards, values, facilityId, excludeRewards) => {
  let rewardId = undefined;
  for (let myreward of rewards) {
    const dateIsBefore = moment().isBefore(moment.utc(myreward.expiryDateUtc));

    if (
      !dateIsBefore ||
      (!myreward?.applications?.includes(2) &&
        myreward?.benefitType !== BENEFIT_TYPE.REFERAL)
    ) {
      // if includes 1 (guest) and 2 (backoffice) then it means it is applicable for both
      continue;
    }
    if (myreward.facilityExcludeType === EXCLUSION_TYPE["All Included"]) {
      // koi b facility ho us pe apply hoga reward   AllIncluded = 1,
      rewardId = checkForProductExcludeType(myreward, values, excludeRewards);
    } else if (
      myreward.facilityExcludeType === EXCLUSION_TYPE["Only Included"]
    ) {
      // jo facility ho us pe apply hoga reward OnlyInclude = 2,
      if (myreward?.facilityIds?.includes(facilityId)) {
        // return myreward?.customerRewardIds[0];
        rewardId = checkForProductExcludeType(myreward, values, excludeRewards);
      }
    } else if (
      myreward.facilityExcludeType === EXCLUSION_TYPE["All Included Except"]
    ) {
      // all include except facility list jo aarhi ho AllIncludeExcept = 3
      if (!myreward?.facilityIds.includes(facilityId)) {
        // return myreward?.customerRewardIds[0];
        rewardId = checkForProductExcludeType(myreward, values, excludeRewards);
      }
    }
    if (rewardId) return rewardId;
  }
  return;
  // customerRewardIds se koi b ID utha k replace krna hoga order mai
};

export const getFirstRewardIdFromRewards = (
  rewards,
  values,
  facilityId,
  excludeRewards
) => {
  let rewardIds = [];
  for (let myreward of rewards) {
    const dateIsBefore = moment().isBefore(moment.utc(myreward.expiryDateUtc));
    let reward = null;
    if (
      !dateIsBefore ||
      (!myreward?.applications?.includes(2) &&
        myreward?.benefitType !== BENEFIT_TYPE.REFERAL)
    ) {
      // if includes 1 (guest) and 2 (backoffice) then it means it is applicable for both
      continue;
    } else if (
      myreward.facilityExcludeType === EXCLUSION_TYPE["All Included"]
    ) {
      // koi b facility ho us pe apply hoga reward   AllIncluded = 1,
      reward = checkForProductExcludeType(myreward, values, excludeRewards);
    } else if (
      myreward.facilityExcludeType === EXCLUSION_TYPE["Only Included"]
    ) {
      // jo facility ho us pe apply hoga reward OnlyInclude = 2,
      if (myreward?.facilityIds?.includes(facilityId)) {
        // return myreward?.customerRewardIds[0];
        reward = checkForProductExcludeType(myreward, values, excludeRewards);
      }
    } else if (
      myreward.facilityExcludeType === EXCLUSION_TYPE["All Included Except"]
    ) {
      // all include except facility list jo aarhi ho AllIncludeExcept = 3
      if (!myreward?.facilityIds.includes(facilityId)) {
        // return myreward?.customerRewardIds[0];
        reward = checkForProductExcludeType(myreward, values, excludeRewards);
      }
    }
    if (!!reward) rewardIds.push(reward);
  }
  return rewardIds;
  // customerRewardIds se koi b ID utha k replace krna hoga order mai
};

export const getRewardsText = (item) => {
  let text = "";
  if (item.benefitType == BENEFIT_TYPE["Discount Percentage"]) {
    text = `Discount applied  ${item.benefitValue}% `;
  } else if (item.benefitType == BENEFIT_TYPE["Discount Amount"]) {
    text = `Discount applied fixed discount of $${Number(
      item.discountValue ?? 0
    ).toFixed(2)}`;
  } else if (item.benefitType == BENEFIT_TYPE["Bonus Service"]) {
    text = `Bonus Service`;
  } else if (item.benefitType == BENEFIT_TYPE["REFERAL"]) {
    text = `Referral bonus of $${Number(item.discountValue ?? 0).toFixed(2)}`;
  }
  return text;
};

export const getProgramText = (item) => {
  let text = "";
  if (item.benefitType == BENEFIT_TYPE["Discount Percentage"]) {
    text = `Discount:  ${item.benefitValue}% `;
  } else if (item.benefitType == BENEFIT_TYPE["Discount Amount"]) {
    text = `Discount: Fixed discount of $${Number(
      item.benefitValue ?? 0
    ).toFixed(2)}`;
  } else if (item.benefitType == BENEFIT_TYPE["Bonus Service"]) {
    text = `Bonus Service`;
  } else if (item.benefitType == BENEFIT_TYPE["REFERAL"]) {
    text = `Referral bonus of $${Number(item.benefitValue ?? 0).toFixed(2)}`;
  }
  return text;
};

export const getDefaultDaySlots = () => {
  const slots = [];
  for (let i = 1; i <= 31; i++) {
    slots.push({
      value: i,
      disabled: true,
      date: `2023-03-${i}T19:00:00.000Z`,
    });
  }
  return slots;
};

function generatePercentageObjects() {
  const percentages = [];
  for (let i = 1; i <= 100; i++) {
    percentages.push({ value: i, label: `${i}%` });
  }
  return percentages;
}

export const PercentageArray = generatePercentageObjects();

export const getProgramNameFromBenefitType = (benefitType) => {
  if (benefitType === BENEFIT_TYPE["Bonus Service"]) return "Program";
  else if (
    benefitType === BENEFIT_TYPE["Discount Amount"] ||
    benefitType === BENEFIT_TYPE["Discount Percentage"]
  )
    return "Membership";
  else if (benefitType === BENEFIT_TYPE.REFERAL) return "Referral";
  return "";
};

export const injectRewards = (data = {}, rewards = [], facilityId) => {
  let availedRewards = [];
  let isRewardsAttached = false;
  for (let lineItem of data.lineItems ?? []) {
    const rewardId = getRewardId(rewards, lineItem, facilityId, availedRewards);
    if (rewardId) {
      isRewardsAttached = true;
      lineItem.rewardId = rewardId;
      availedRewards.push(rewardId);
    }
    // eslint-disable-next-line no-loop-func
    lineItem.addOns = lineItem.addOns.map((addOn) => {
      const rewardId = getRewardId(rewards, addOn, facilityId, availedRewards);
      if (rewardId) {
        isRewardsAttached = true;
        addOn.rewardId = rewardId;
        availedRewards.push(rewardId);
      }
      return addOn;
    });
  }
  return isRewardsAttached;
};

/**
 * Converts an image file to a compressed data URL.
 *
 * @param {File} file - The image file to compress.
 * @param {number} [maxWidth=800] - The maximum width of the compressed image.
 * @param {number} [maxHeight=600] - The maximum height of the compressed image.
 * @param {number} [quality=0.7] - The quality of the compressed image (0.0 - 1.0).
 * @param {string} [outputFormat='image/jpeg'] - The output format of the compressed image.
 * @returns {Promise<string>} A promise that resolves with the compressed data URL.
 * @throws {Error} Throws an error if the file is not an image or if there is an error during compression.
 */
export const compressImage = (
  file,
  maxWidth = 800,
  maxHeight = 600,
  quality = 0.7,
  outputFormat = "image/jpeg"
) => {
  return new Promise((resolve, reject) => {
    console.log("file", file);
    if (!file.type.startsWith("image/")) {
      reject(new Error("File is not an image."));
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        let width = img.width;
        let height = img.height;

        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width *= ratio;
          height *= ratio;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        try {
          const dataUrl = canvas.toDataURL(outputFormat, quality);
          resolve(dataUrl);
        } catch (error) {
          reject(error);
        }
      };
      img.onerror = (error) => {
        reject(error);
      };
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

export function getBackgroundColorAndTooltip(order) {
  let bgColor = "";
  let tooltip = "";

  if (ORDER_STATUS_MAPPING[order?.orderStatus]?.text === "Arrived") {
    bgColor = "bg-green";
    tooltip = "Nurse has arrived.";
  } else if (ORDER_STATUS_MAPPING[order?.orderStatus]?.text === "No Show") {
    bgColor = "bg-orange";
    tooltip = "Nurse has marked 'No Show'.";
  } else if (ORDER_STATUS_MAPPING[order?.orderStatus]?.text === "Cancelled") {
    bgColor = "bg-orange";
    tooltip = "Appointment Cancelled.";
  } else if (ORDER_STATUS_MAPPING[order?.orderStatus]?.text === "Completed") {
    bgColor = "bg-lime";
    tooltip = "Completed.";
  } else if (moment().isAfter(moment(order.serviceDate).add(15, "minutes"))) {
    bgColor = "bg-red";
    tooltip = "Nurse has not yet arrived.";
  } else if (ORDER_STATUS_MAPPING[order?.orderStatus]?.text !== "Arrived") {
    bgColor = "bg-blue";
    tooltip = "Pending booking.";
    if (order?.isMultipleGuestBooking) {
      bgColor = "bg-purple";
      tooltip = "Pending Multiple Guest Booking";
    }
  }
  return [bgColor, tooltip];
}

export function autoAbbreviate(phrase) {
  const splittedPhrase = phrase?.split(" ");

  if (splittedPhrase?.length <= 2) {
    const firstWord = splittedPhrase[0];
    if (firstWord?.length <= 7) {
      return firstWord; // No abbreviation needed
    }
    return firstWord.slice(0, 7) + "..."; // No abbreviation needed
  }

  return (
    phrase
      .split(" ")
      .map((word) => word.slice(0, 3)) // Take first 3 letters
      .join(" ") + "..."
  );
}


export function checkisManageRewardsDisabled(booking, currentUser) {
  const isVoucherApplied = booking?.voucherCode && booking?.discount
  const hasDiscountManagementPermission = currentUser?.permissions?.find(permission => permission?.permissionName === "Discount Management");


  if (isVoucherApplied && !hasDiscountManagementPermission) {
    return true
  }


  return false
}

export function getServerErrorString(e) {
  if (e?.response?.data) {
    if (typeof e?.response?.data === 'string') {
      return e?.response?.data
    } else if (e?.response?.data?.length > 0) {
      return e?.response?.data?.[0]?.description || e?.response?.data?.[0]
    } else {
      return e?.response?.data?.message ||
        e?.response?.data?.Message
    }
  }


  return e?.response?.Message ||
    e?.response?.message ||
    e?.Message ||
    e?.message ||
    "Something went wrong"
}